import { createCustomEnum } from "./customEnum";

const WithholdStatuses = createCustomEnum({
	LegalRequest: {
		name: "legalRequest",
		value: 4,
		displayName: "Legal request",
	},
	MissingPayoutDetails: {
		name: "missingPayoutDetails",
		value: 6,
		displayName: "Missing payout details",
	},
	Other: {
		name: "other",
		value: 5,
		displayName: "Other",
	},
	ProspectiveAgentPartner: {
		name: "prospectiveAgentPartner",
		value: 1,
		displayName: "Prospective agent/ partner",
	},
	RiskRequest: {
		name: "riskRequest",
		value: 3,
		displayName: "Risk request",
	},
	TerminatedAgentPartner: {
		name: "terminatedAgentPartner",
		value: 2,
		displayName: "Terminated agent/ partner",
	},
});

export default WithholdStatuses;

export const MerchantWithholdStatuses = [
	WithholdStatuses.LegalRequest,
	WithholdStatuses.Other,
	WithholdStatuses.RiskRequest,
];

export const ManualWithholdStatuses = createCustomEnum({
	Yes: { value: "1", name: "yes", displayName: "Yes" },
	No: { value: "0", name: "no", displayName: "No" },
});
